import ProductsRegistration from './ProductsRegistration';

export default ProductsRegistration;